import React from "react";
import { LegacyCard, InlineGrid, TextField, Select } from "@shopify/polaris";
import CustomAutocomplete from "../CustomAutocomplete";
import { ButtonNumber } from "../CoatData";

const MenShortForm = ({
  form,
  setForm,
  errors,
  conditionalFieldsMap,
}) => {
  const handleChange =
    (section, key = null) =>
    (values) => {
      const trimmedKey = key?.trim();
      let value;
      if (Array.isArray(values)) {
        value = values[0];
      } else {
        value = values;
      }

      const sectionMap = conditionalFieldsMap[section];
      const fieldRule = sectionMap?.[trimmedKey];

      if (fieldRule) {
        const { conditionValue, dependentKey } = fieldRule;
        if (value === conditionValue) {
          // Add the dependent field
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [trimmedKey]: value,
              [dependentKey]: "",
            },
          }));
        } else {
          // Remove the dependent field
          const updatedSection = { ...form[section] };
          delete updatedSection[dependentKey];
          updatedSection[trimmedKey] = value;

          setForm((prev) => ({
            ...prev,
            [section]: updatedSection,
          }));
        }

        return;
      }
      // Default update
      if (trimmedKey) {
        setForm((prev) => ({
          ...prev,
          [section]: {
            ...prev[section],
            [trimmedKey]: value,
          },
        }));
      } else {
        setForm((prev) => ({
          ...prev,
          [section]: value,
        }));
      }
    };

  const menShortFields = [
    {
      label: "Front Style",
      key: "frontStyle",
      type: "select",
      options: [
        "No Pleat",
        "Single Pleat",
        "Double Pleat ",
      ],
    },
    {
      label: "Front Pocket",
      key: "frontPocket",
      type: "select",
      options: ["Slant", "Sideseam", "Besom", "Jean"],
    },
    {
      label: "Back Pocket",
      key: "backPocket",
      type: "select",
      options: [
        "Besom with Button",
        "Besom",
        "Jean Patch with Point",
        "No Back Pocket",
      ],
    },
    {
      label: "Bottom Style",
      key: "bottomStyle",
      type: "select",
      options: ["Regular", "Cuff 1"],
    },
    {
      label: "Waistband Closure",
      key: "waistbandClosure",
      type: "select",
      options: ["Hook & Button", "Hook & Hook", "No Extention with Button", "No Extention with Hook"],
    },
    {
      label: "Belt Loop",
      key: "beltLoop",
      type: "select",
      options: ["Regular", "No"],
    },
    {
      label: "Side Tabs",
      key: "sideTabs",
      type: "select",
      options: ["No","Yes"],
    },
    {
      label: "Waist Width",
      key: "waistWidth",
      type: "select",
      options: ["1 1/2", "2"],
    },
    {
      label: "Button Number",
      key: "buttonNumber",
      type: "select",
    },
  ];

  const renderSection = (title, fields, sectionKey) => (
    <LegacyCard title={title} sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        {fields.map(({ label, key, type = "text", options = [] }) => {
          if (type === "select") {
            return (
                <React.Fragment key={key}>
                {key !== "buttonNumber" && (
                  <div className="two_culumn">
                    <Select
                      label={label}
                      options={options}
                      value={form[sectionKey]?.[key] || ""}
                      onChange={handleChange(sectionKey, key)}
                      error={errors[sectionKey]?.[key]}
                    />
                  </div>
                )}
                {key === "buttonNumber" && (
                  <CustomAutocomplete
                    label={label}
                    optionsList={ButtonNumber}
                    onChange={handleChange(sectionKey, key)}
                    defaultValue={form[sectionKey]?.[key] || ""}
                  />
                )}
              </React.Fragment>
            );
          }
          return (
            <TextField
              key={key}
              label={label}
              value={form[sectionKey]?.[key] || ""}
              onChange={handleChange(sectionKey, key)}
              error={errors[sectionKey]?.[key]}
            />
          );
        })}
      </InlineGrid>
    </LegacyCard>
  );

  return renderSection("Men Short", menShortFields, "menShort");
};

export default MenShortForm;
